import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import qs from 'qs';
//import wx from 'weixin-js-sdk';
//import 'fullpage.js/vendors/scrolloverflow';
//import VueFullPage from 'vue-fullpage.js';
//import ElementUI from 'element-ui'
//import i18n from './i18n/i18n'
//import vueToTop from 'vue-totop'

//import 'element-ui/lib/theme-chalk/index.css'

import './assets/fonts/fonts.css'

//import store from './store';


import "lib-flexible/flexible"       // 自适配
//import FastClick from 'fastclick'    // 移动端300ms延迟

import '@vant/touch-emulator';
import { Toast } from 'vant';
import { Image as VanImage } from 'vant';
//import { Circle } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Dialog } from 'vant';
import { CountDown } from 'vant';
import { Button } from 'vant';
import { Lazyload } from 'vant';
import { Loading } from 'vant';
import { Overlay } from 'vant';
import { Icon } from 'vant';

Vue.use(Toast);
Vue.use(VanImage);
//Vue.use(Circle);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Dialog);
Vue.use(CountDown);
Vue.use(Button);
Vue.use(VanImage);
Vue.use(Lazyload);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(Icon);

//Vue.use(vueToTop)

//Vue.use(VueFullPage);

// import axios from 'axios'
// axios.defaults.withCredentials=true;
// Vue.prototype.axios = axios;
//axios.defaults.baseURL = '/api';

Vue.config.productionTip = false;

//FastClick.attach(document.body);

router.beforeEach((to, from, next) => {
	//document.title = i18n.t('title.title');
	document.title = to.meta.title;
	next();
});

router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
